// extracted by mini-css-extract-plugin
export var banner = "_o0-0";
export var settingRow = "_o0-2";
export var titleIcon = "_o0-1";